import { AxiosResponse } from 'axios';
import services from '../services/hoa-dashboard-api-service';
import config from '../hoa-config';
const _ = require('lodash');

export function compareObjects(a:any, b:any){
  return _.isEqual(a, b);
}

export async function fetchSignedUrlFromS3(path: string): Promise<AxiosResponse<any>> {
    return await services.getSignedUrl(path);
}

export async function getSpecificEmailsDataSortedByDateRange(fromDate: string, toDate: string) {
    try {
        const response = await services.getSpecificEmailsDataSortedByDateRange(fromDate, toDate);
        if(response.data.type === 'application/json') {
            window.alert('No Mail Data Exist on this date range!!');
            return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `Filtered Email List-(${new Date(fromDate).toLocaleDateString()}-${new Date(toDate).toLocaleDateString()}).xlsx`;
        a.id = 'download-link';
        a.click();
        window.URL.revokeObjectURL(url);
        const downloadLink = document.getElementById('download-link');
        if (downloadLink) {
            downloadLink.remove();
        }
    } catch (error) {
        window.alert(error);
    }
}

export async function getSpecificEmailsDataSortedByDate(fromDate: string, toDate: string) {
    try {
        const response = await services.getSpecificEmailsDataSortedByDate(fromDate, toDate);
        if(response.data.type === 'application/json') {
            window.alert('No Mail Data Exist on this date range!!');
            return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `Filtered Mail List-(${new Date(fromDate).toLocaleDateString()}-${new Date(toDate).toLocaleDateString()}).xlsx`;
        a.id = 'download-link';
        a.click();
        window.URL.revokeObjectURL(url);
        const downloadLink = document.getElementById('download-link');
        if (downloadLink) {
            downloadLink.remove();
        }
    } catch (error) {
        window.alert(error);
    }
}

export function camelCaseToSeparatedWords(text:string) {
    const separatedText = text.replace(/([a-z])([A-Z])/g, '$1 $2');
    return separatedText
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

export function filterVisiblePropertiesObj(basicInfo:any, visibilityInfo:any) {
    let filteredInfo:any = {};

    for (let key in basicInfo) {
        if (key in visibilityInfo) {
            if (visibilityInfo[key].isVisible) {
                filteredInfo[key] = basicInfo[key];
            }
        }else{
            filteredInfo[key] = basicInfo[key]; 
        }
    }

    return filteredInfo;
}

type FieldData = {
    isVisible: boolean;
    fieldName: string[];
  };
  
  type SectionData = {
    [key: string]: FieldData | SectionData;
  };

export function getFieldNamesWithInvisibleFields(section: any) {
  const invisibleFieldNames: string[] = [];

  if (!section) {
      return invisibleFieldNames;
  }

  function checkItems(items: any) {
      for (const item in items) {
          const value = items[item];
          if (value && typeof value === 'object') {
              if ('isVisible' in value) {
                  if (value.isVisible === false) {
                      const fieldName = value.fieldName;
                      if (Array.isArray(fieldName)) {
                          invisibleFieldNames.push(...fieldName);
                      } else {
                          invisibleFieldNames.push(fieldName);
                      }
                  }
                  checkItems(value)
              }
              else{
                  checkItems(value)
              }
          }
      }
  }

  for (const category in section) {
      const items = section[category];
      checkItems(items);
  }

  return invisibleFieldNames;
}

export function getPropertyNamesWithInvisibleFields(section: any,subSection=false) {
  const invisiblePropertyNames: string[] = [];
  
  if (!section) {
      return invisiblePropertyNames;
  }
  
  function checkItems(items: any) {
      for (const item in items) {
          const value = items[item];
          if (value && typeof value === 'object') {
              if ('isVisible' in value) {
                  if (value.isVisible === false) {
                      invisiblePropertyNames.push(item);
                  }
                  checkItems(value)
              } else {
                  checkItems(value); // Continue checking other properties recursively
              }
          }
      }
  }
  if(subSection){
    checkItems(section)
  }else{
      for (const category in section) {
          const items = section[category];
          checkItems(items);
        }
    }
  
  return invisiblePropertyNames;
}

interface FieldConfig {
	isVisible: boolean;
	fieldName: string[];
  }
interface NestedFieldConfig {
	[key: string]: FieldConfig | NestedFieldConfig;
}
interface Config {
	[key: string]: NestedFieldConfig;
  }
  export const countVisibleFields = (sectionName: keyof Config,permittedFields:Config): number => {
    const countFields = (obj: NestedFieldConfig): number => {
      return Object.values(obj).reduce((count, value) => {
        if ('isVisible' in value) {
          return count + 1;
        }
        return count + countFields(value as NestedFieldConfig);
      }, 0);
    };
  
    if (permittedFields && permittedFields[sectionName]&& Object.keys(permittedFields[sectionName]).length) {
      return countFields(permittedFields[sectionName]);
    } else {
      return 0;
    }
  };
  
  
export const checkVisibilityByParent = (parentName: keyof Config,permittedFields:Config): boolean => {
    const checkVisibility = (obj: NestedFieldConfig): boolean => {
      return Object.values(obj).every(value => {
        if ('isVisible' in value) {
          return !value.isVisible; // Return false if any field is visible
        }
        return checkVisibility(value as NestedFieldConfig);
      });
    };
  if(permittedFields){
      return checkVisibility(permittedFields[parentName]);
    }
    else{
        return false
    }
  };

export function filterVisiblePropertiesArray(basicInfoArray:any, visibilityInfo:any) {
    return basicInfoArray.filter((key:any) => {
        return !(key in visibilityInfo) || visibilityInfo[key].isVisible;
    });
}

export function getStateNameAbbreviation(stateName:string) {
    if (Array.isArray(config.stateNameAbbreviations)) {
        for (const item of config.stateNameAbbreviations) {
            if (item.name.toLowerCase() === stateName.toLowerCase()) {
                return item.abbreviation;
            }
        }
    }
}

export const convertTo12HourFormat=(time24:any)=> {
    const [hours, minutes] = time24.split(':');
    let hours12 = parseInt(hours, 10);
    const suffix = hours12 >= 12 ? 'PM' : 'AM';
    hours12 = hours12 % 12 || 12;
    const time12 = `${hours12}:${minutes} ${suffix}`;
    return time12;
}

export function getFileExtension(fileName:any) {
    if (fileName) {
        const extension = fileName.split('.').pop();
        return extension;
    }
}

export function getFileNameWithoutExtension(fileName:any) {
    if (fileName) {
        const fileNameParts = fileName.split('.');
        if (fileNameParts.length >= 2) {
            fileNameParts.pop();
            fileName = fileNameParts.join('.');
        }
    }

    return fileName;
}

export function isViolationExtension(extension:string) {
    return extension.includes('New Violation is Added')
        || extension.includes('New Stage of a Violation is Added')
        || extension.includes('Update Violation Information')
        || extension.includes('Stage of a Violation is Deleted')
        || extension.includes('Violation is Deleted')
        || extension.includes('Violation is Resolved')
}

export function shouldApplyEffectiveDate(effectiveDate:string) {
    const dateObj = new Date(effectiveDate);
    const currentDate = new Date();

    if (dateObj > currentDate) {
        return true;
    }

    return false;
}

export const notificationTypeValuePopulate = (value:any) => {
    if(!value) return 'N/A';

    if(value.includes('Email') && value.includes('Written Notice')) {
        return 'Written Notice, Email';
    } else if(value.includes('Email') || value.includes('Written Notice')){
        return value;
    }
}

export const renderPeriod = (period:any, timeline:string) => {
    let periodString = "N/A";

    if(period || timeline) {
        periodString = `${period} ${timeline}`;
    }

    return periodString;
}

export const notAvailableComponentTitleByTabIndex = (tabIndex: number) => {
	if (tabIndex === 1) {
		return {
			title: "No Procedure Added Yet",
			subTitle: "Please add procedures to update the HOA information.",
		};
	}
	// if (tabIndex === 2) {
	// 	return {
	// 		title: "No Amenities Added Yet",
	// 		subTitle: "Please add amenities to update the HOA information.",
	// 	};
	// }
	if (tabIndex === 2) {
		return {
			title: "No Amenities Added Yet",
			subTitle: "Please add amenities to update the HOA information.",
		};
	}
	if (tabIndex === 3) {
		return {
			title: "No Violation Regulation Added Yet",
			subTitle: "Please add the violation regulations to update the HOA information.",
		};
	}
};

export const urlCheck = (url:string) => {
    if(url) {
        return url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
    }
    return "";
}

export const getAmenitiesIcon = (type:string) => {
    return config.amenityIcons[type];
}

function isFirstGreaterThanSecond(violation1:any, violation2:any) {
  if (!violation1 || !violation2) {
    false;
  }

  const noticeDate1 = violation1.noticeDate;
  const noticeDate2 = violation2.noticeDate;
  let date1:any;
  let date2:any;

  try {
    date1 = new Date(noticeDate1);
    date2 = new Date(noticeDate2);
  }
  catch(ex) {}

  // consider invalid date greater than valid date
  if (!isNaN(date1) && isNaN(date2)) {
    return false;
  }
  else if (isNaN(date1) && !isNaN(date2)) {
    return true;
  }
  else if (date1 > date2) {
    return true;
  }
  else if (date2 > date1) {
    return false;
  }
  else {
    // now compare using violation stage
    // violationStageNotices
    let stage1 = violation1.stage;
    let stage2 = violation2.stage;

    // consider invalid stage greater than valid stage
    if (!stage1 && stage2) {
      return true;
    }
    else if (stage1 && !stage2) {
      return false;
    }
    else if (config.violationStageNotices.indexOf(stage1) < config.violationStageNotices.indexOf(stage2)) {
      return false;
    }
    else if (config.violationStageNotices.indexOf(stage2) < config.violationStageNotices.indexOf(stage1)) {
      return true;
    }
    else {
      let createdDate1 = violation1.createdAt;
      let createdDate2 = violation2.createdAt;

      let createdDateObj1:any;
      let createdDateObj2:any;

      try {
        createdDateObj1 = new Date(createdDate1);
        createdDateObj2 = new Date(createdDate2);
      }
      catch(ex) {}

      // consider invalid date greater than valid date
      if (isNaN(createdDateObj1) && !isNaN(createdDateObj2)) {
        return true;
      }
      else if (!isNaN(createdDateObj1) && isNaN(createdDateObj2)) {
        return false;
      }
      else if (createdDate1 > createdDate2) {
        true;
      }
      else if (createdDate2 > createdDate1) {
        return false
      }
      else {
        return false;
      }
    }
  }
}

export function sortViolations(violationList:any) {
  if (Array.isArray(violationList) && violationList.length > 0) {
    const length = violationList.length;

    for (let i = 0; i<length; i++) {
      for (let j = 0; j<length-i-1; j++) {
        if (!isFirstGreaterThanSecond(violationList[j], violationList[j+1])) {
          let temp: any = violationList[j];
          violationList[j] = violationList[j+1];
          violationList[j+1] = temp;
        }
      }
    }

    return violationList;
  }
}
